// vendor
import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

const DEFAULT_UTC_TIME = '00:00:00.000Z';

@Injectable({
  providedIn: 'root',
})
export class DateService {
  constructor(private datePipe: DatePipe) {}

  getDaysIntoFuture(referenceDate: string, daysAfter: number) {
    const future = new Date(referenceDate);
    future.setDate(future.getDate() + daysAfter);
    return future;
  }

  getDaysIntoPast(referenceDate: string, daysBefore: number) {
    const future = new Date(referenceDate);
    future.setDate(future.getDate() - daysBefore);
    return future;
  }

  getFormattedUTCDateOnlyStr(date: string, format = 'MM/dd/yyyy'): string {
    // ensure date only
    const dateOnly = this.removeTimeFromISODateString(date);
    return this.datePipe.transform(dateOnly, format, 'UTC');
  }

  removeTimeFromISODateString(dateStr: string): string {
    if (dateStr) {
      return `${dateStr.split('T')[0]}T${DEFAULT_UTC_TIME}`;
    }
    return null;
  }

  getPreviousUTCDateStr(days: number): string {
    const today = new Date();
    const prevDate = new Date(today.setDate(today.getDate() - days));
    return this.removeTimeFromISODateString(prevDate.toISOString());
  }
}
